"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const globalErrorCode_1 = require("../global/model/error/globalErrorCode");
const userError_1 = require("./model/error/userError");
const userErrorCode_1 = require("./model/error/userErrorCode");
class User {
    constructor(instance) {
        this.instance = instance;
    }
    getMyProfile(token) {
        return new Promise((resolve, reject) => {
            const URL = '/users/me';
            if (!token) {
                reject(new userError_1.UserError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const auth = res.data;
                resolve(auth);
            })
                .catch((err) => {
                reject(this.handleError(err));
            });
        });
    }
    updateProfile(token, newProfile) {
        return new Promise((resolve, reject) => {
            const URL = '/profilemerchants';
            if (!token) {
                reject(new userError_1.UserError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.put(URL, newProfile, config)
                .then((res) => {
                const data = res.data;
                delete data.user;
                const profile = data;
                resolve(profile);
            })
                .catch((err) => {
                reject(this.handleError(err));
            });
        });
    }
    getMyBalance(token) {
        return new Promise((resolve, reject) => {
            const URL = '/users/me/balance';
            if (!token) {
                reject(new userError_1.UserError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = {
                headers: {
                    Authorization: authStr,
                },
                timeout: 100000,
            };
            this.instance.get(URL, config)
                .then((res) => {
                const balance = res.data.balance;
                resolve(balance);
            })
                .catch((err) => {
                reject(this.handleError(err));
            });
        });
    }
    getEmailByAddress(token, address) {
        return new Promise((resolve, reject) => {
            const URL = `/address/${address}`;
            if (!token) {
                reject(new userError_1.UserError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const email = res.data.email;
                resolve(email);
            })
                .catch((err) => {
                reject(this.handleError(err));
            });
        });
    }
    changePassword(token, oldPassword, newPassword) {
        return new Promise((resolve, reject) => {
            const URL = '/auth/change-password';
            if (!token) {
                reject(new userError_1.UserError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            if (!oldPassword) {
                reject(new userError_1.UserError(userErrorCode_1.UserErrorCode.INVALID_PASSWORD));
                return;
            }
            if (!newPassword) {
                reject(new userError_1.UserError(userErrorCode_1.UserErrorCode.INVALID_PASSWORD));
                return;
            }
            else if (newPassword.length < 6) {
                reject(new userError_1.UserError(userErrorCode_1.UserErrorCode.INVALID_PASSWORD));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance
                .post(URL, {
                oldPassword,
                newPassword,
            }, config)
                .then((res) => {
                const auth = res.data;
                resolve(auth);
            })
                .catch((err) => {
                reject(new userError_1.UserError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.message));
            });
        });
    }
    handleError(error) {
        if (error.response.data.message === 'Invalid token.') {
            return new userError_1.UserError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN);
        }
        else {
            return new userError_1.UserError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.message);
        }
    }
}
exports.User = User;
//# sourceMappingURL=user.js.map